export const ARTICLE_COVERS = [
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660444/assets/price-analysis/jcxoohyc63slhtgporqm.png',
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660444/assets/price-analysis/y0zmb6ax19dwakejniqk.png',
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660443/assets/price-analysis/mxwcukcsnmrmofoezspj.png',
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660443/assets/price-analysis/q1e6rqt4pquhcvxlutbg.png',
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660443/assets/price-analysis/xhnwx2crxe27ecqosj72.png',
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1718660443/assets/price-analysis/gsp5sjupxgkiadwpneok.png',
]
